let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

window.addEventListener('resize', () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

/* *********************************** */
const stopscroll = document.getElementById('top_page');

function existVerticalScroll() {
	return document.body.offsetHeight > window.innerHeight
 }
function getBodyScrollTop() {
	return self.pageYOffset || (document.documentElement && document.documentElement.ScrollTop) || (document.body && document.body.scrollTop);
  }

document.getElementById('mob_btn').addEventListener('click', function () {
	stopscroll.dataset.scrollY = getBodyScrollTop() // сохраним значение скролла
	stopscroll.classList.add('menu_open');
	if(existVerticalScroll()) {
		//stopscroll.classList.add('menu_open')
		stopscroll.style.top = `-${stopscroll.dataset.scrollY}px`
	  }
});
document.querySelectorAll('.close_item').forEach(item => {
	item.addEventListener('click', event => {
		stopscroll.classList.remove('menu_open');
		if(existVerticalScroll()) {
			//stopscroll.classList.remove('bmenu_open')
			window.scrollTo(0,stopscroll.dataset.scrollY)    
		   }
	});
});

var waterReadingsEl = document.getElementById('water-readings');

// Check if the element exists
if(waterReadingsEl) {
	waterReadingsEl.addEventListener('submit', function(event) {
		var waterReadingsSubmitButton = waterReadingsEl.querySelector('button[type="submit"]');

		event.preventDefault();
		var formData = new FormData(this);

		waterReadingsSubmitButton.disabled = true;


		// Generate reCAPTCHA token
		grecaptcha.ready(function() {
			grecaptcha.execute('6LdI1WApAAAAAPdQTtFxTYeDCstZ_-pVdNB3PbIG', {action: 'submit'}).then(function(token) {
				// Add reCAPTCHA token to the form data
				formData.append('g-recaptcha-response', token);

				// Proceed with form submission
				fetch('/sendEmail.php', {
					method: 'POST',
					body: formData
				})
					.then(response => {
						if (!response.ok) {
							throw new Error("Receive non-2XX response from the server");
							alert("Näitude edastamine ebaõnnestus. Palun proovige uuesti");

						}
						return response.json().catch(error => {
							throw new Error(`Error in parsing server response: ${error}`);
						});
					})
					.then(data => {
						// Display server data
						console.log(data);
						waterReadingsEl.reset();
						waterReadingsSubmitButton.disabled = false;
						// Display thank you message
						alert("Näitude edastamine õnnestus. Täname!");
					})
					.catch(error => {
						console.error(`An error occurred: ${error}`);
					});
			});
		});
	});
} else {
	console.error("Couldn't find the element with id 'water-readings'");
}

var priceRequestEl = document.getElementById('price-request');

if(priceRequestEl) {
	priceRequestEl.addEventListener('submit', function(event) {
		var priceRequestSubmitButton = priceRequestEl.querySelector('button[type="submit"]');

		event.preventDefault();
		var formData = new FormData(this);

		// Disable the submit button
		priceRequestSubmitButton.disabled = true;

		// Generate reCAPTCHA token
		grecaptcha.ready(function() {
			grecaptcha.execute('6LdI1WApAAAAAPdQTtFxTYeDCstZ_-pVdNB3PbIG', {action: 'submit'}).then(function(token) {
				// Add reCAPTCHA token to the form data
				formData.append('g-recaptcha-response', token);

				// Proceed with form submission
				fetch('/sendEmail.php', {
					method: 'POST',
					body: formData
				})
					.then(response => {
						if (!response.ok) {
							throw new Error("Receive non-2XX response from the server");
							alert("Hinnapäringu edastamine ebaõnnestus. Palun proovige uuesti");

						}
						return response.json().catch(error => {
							throw new Error(`Error in parsing server response: ${error}`);
						});
					})
					.then(data => {
						// Display server data
						console.log(data);
						// Display thank you message
						alert("Hinnapäring on saadetud, täname! Võtame Teiega ühendust.");
						priceRequestEl.reset();
						priceRequestSubmitButton.disabled = false;
					})
					.catch(error => {
						console.error(`An error occurred: ${error}`);
						// Enable the submit button in case of error
						priceRequestSubmitButton.disabled = false;
					});
			});
		});
	});
} else {
	console.error("Couldn't find the element with id 'price-request'");
}

document.querySelectorAll('.modal_btn').forEach(item => {
	item.addEventListener('click', event => {
	stopscroll.dataset.scrollY = getBodyScrollTop() // сохраним значение скролла
	stopscroll.classList.add('modal_open');
	if(existVerticalScroll()) {
		//stopscroll.classList.add('modal_open')
		stopscroll.style.top = `-${stopscroll.dataset.scrollY}px`
	  }
	});
});
document.querySelectorAll('.close_modal').forEach(item => {
	item.addEventListener('click', event => {
		stopscroll.classList.remove('modal_open');
		if(existVerticalScroll()) {
			//stopscroll.classList.remove('bmenu_open')
			window.scrollTo(0,stopscroll.dataset.scrollY)    
		   }
	});
});

/* *********************************** */

const $slider = document.querySelector('[data-slider="chiefslider"]');
const slider = new ChiefSlider($slider, {
	loop: true,
	autoplay: true,
	interval: 7000,
	refresh: true,
	swipe: true
});
//# sourceMappingURL=app.js.map
